const YoutubeCircleIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="38" height="38" rx="19" fill="currentColor" />
        <path
          d="M23.0924 14.0479H14.9076C13.3018 14.0479 12 15.3496 12 16.9555V21.047C12 22.6528 13.3018 23.9546 14.9076 23.9546H23.0924C24.6982 23.9546 26 22.6528 26 21.047V16.9555C26 15.3496 24.6982 14.0479 23.0924 14.0479ZM21.126 19.2003L17.2977 21.0262C17.1957 21.0748 17.0779 21.0004 17.0779 20.8874V17.1216C17.0779 17.007 17.1988 16.9327 17.301 16.9845L21.1293 18.9245C21.2431 18.9822 21.2411 19.1454 21.126 19.2003Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default YoutubeCircleIcon;
